import { createAppReducerSimpleFetch } from "shared/redux-store/defaults";
import reduceReducers from "reduce-reducers";

const digitalizedOrdersAppReducerFetch = createAppReducerSimpleFetch(
  "DIGITALIZED_ORDERS",
  ["digitalizedOrders"],
);

const digitalizedOrdersDetailAppReducerFetch = createAppReducerSimpleFetch(
  "DIGITALIZED_ORDERS_DETAIL",
  ["digitalizedOrder"],
);

export default reduceReducers(
  digitalizedOrdersAppReducerFetch,
  digitalizedOrdersDetailAppReducerFetch,
);
